'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024$0024anon$0024140 from "./presto.types$-U-R-L$$anon$140.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024$0024anon$0024141 from "./presto.types$-U-R-L$$anon$141.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024$0024anon$0024142 from "./presto.types$-U-R-L$$anon$142.js";
var $p;
/** @constructor */
function $c_Lpresto_types$URL$() {
  this.ccH = null;
  this.ccI = false;
  this.ccF = null;
  this.ccG = false;
  this.ccJ = null;
  this.ccK = false;
  this.ccL = null;
  this.ccM = false;
  this.ccD = null;
  this.ccE = false;
  this.ccB = null;
  this.ccC = false;
}
export { $c_Lpresto_types$URL$ as $c_Lpresto_types$URL$ };
$p = $c_Lpresto_types$URL$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$URL$;
/** @constructor */
function $h_Lpresto_types$URL$() {
}
export { $h_Lpresto_types$URL$ as $h_Lpresto_types$URL$ };
$h_Lpresto_types$URL$.prototype = $p;
$p.p9 = (function() {
  if ((!this.ccI)) {
    this.ccH = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.ccI = true;
  }
  return this.ccH;
});
$p.fb = (function() {
  if ((!this.ccG)) {
    this.ccF = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8;
    this.ccG = true;
  }
  return this.ccF;
});
$p.Gw = (function() {
  if ((!this.ccK)) {
    this.ccJ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.ccK = true;
  }
  return this.ccJ;
});
$p.cs5 = (function() {
  if ((!this.ccM)) {
    this.ccL = new $j_presto$002etypes$0024$002dU$002dR$002dL$0024$0024anon$0024140.$c_Lpresto_types$URL$$anon$140(this);
    this.ccM = true;
  }
  return this.ccL;
});
$p.cru = (function() {
  if ((!this.ccE)) {
    this.ccD = new $j_presto$002etypes$0024$002dU$002dR$002dL$0024$0024anon$0024141.$c_Lpresto_types$URL$$anon$141(this);
    this.ccE = true;
  }
  return this.ccD;
});
$p.cH4 = (function() {
  if ((!this.ccC)) {
    this.ccB = new $j_presto$002etypes$0024$002dU$002dR$002dL$0024$0024anon$0024142.$c_Lpresto_types$URL$$anon$142(this);
    this.ccC = true;
  }
  return this.ccB;
});
var $d_Lpresto_types$URL$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$URL$, "presto.types$URL$", ({
  a2U: 1,
  D: 1
}));
export { $d_Lpresto_types$URL$ as $d_Lpresto_types$URL$ };
var $n_Lpresto_types$URL$;
function $m_Lpresto_types$URL$() {
  if ((!$n_Lpresto_types$URL$)) {
    $n_Lpresto_types$URL$ = new $c_Lpresto_types$URL$();
  }
  return $n_Lpresto_types$URL$;
}
export { $m_Lpresto_types$URL$ as $m_Lpresto_types$URL$ };
//# sourceMappingURL=presto.types$-U-R-L$.js.map
